import api from '../../index';

export const GetAllRole = () => api.get('RolesAndPermission/GetAllRoles');
export const AddRole = (data) => api.post('RolesAndPermission/Add-Update', data);
export const GetRolesAndPermissionApi = (roleId) => api.get(`RolesAndPermission/GetModulesPermissionByRolesId/${roleId}`);
export const updatePermissionByrole = (data) => api.post('RolesAndPermission/update-module-permission-for-role', data);
export const DeleteRole = (roleId) => api.delete(`RolesAndPermission/DeleteRole/${roleId}`);